/* TGM product page upsells (22-10-2026)
   "Complete your setup" cards on the product page (snippets/upsell-block.liquid, data-tgm-instant).

   The theme's own toggle only marks a card and adds it later together with the watch. Here:
   - Add puts the card's variant in the cart at once and the button reads "Added"; a second click
     takes it out again;
   - the card never stays marked for the theme, so Add to cart of the watch does not add it twice;
   - the price, the struck price and the "Save x%" label follow the selected variant (a gold buckle
     costs more than a steel one);
   - the cards mirror the cart on load and after any cart change (a line removed in the drawer turns
     the card back to Add).
   Lines added here carry the hidden property _tgm_upsell, so the card removes its own line and
   never a line the customer added some other way. main.js is obfuscated, so this stands alone. */
(function () {
  'use strict';
  if (window.TGMUpsells) return;

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  var PROP = '_tgm_upsell';
  var lastCart = null;

  function cards() {
    return [].slice.call(document.querySelectorAll('[data-tgm-instant="true"]'));
  }
  function request(path, body) {
    return fetch(ROOT + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.text().then(function (t) {
        var data = null;
        try { data = JSON.parse(t); } catch (e) { /* rate limit page */ }
        if (!r.ok || !data) throw new Error(path + ' ' + r.status);
        return data;
      });
    });
  }
  function requestRetry(path, body) {
    return request(path, body).catch(function () {
      return new Promise(function (res) { setTimeout(res, 800); }).then(function () { return request(path, body); });
    });
  }
  function variants(card) {
    if (card._tgmVariants) return card._tgmVariants;
    var el = card.querySelector('.upsell__variant-picker script[type="application/json"]');
    try { card._tgmVariants = el ? JSON.parse(el.textContent) : []; } catch (e) { card._tgmVariants = []; }
    return card._tgmVariants;
  }
  function selectedVariant(card) {
    var id = Number(card.dataset.id);
    return variants(card).filter(function (v) { return Number(v.id) === id; })[0] || null;
  }
  // Shop money format from Liquid (data-tgm-money), e.g. "€{{amount_with_comma_separator}}".
  function money(cents, card) {
    var fmt = (card && card.dataset.tgmMoney) || '\u20ac{{amount_with_comma_separator}}';
    var fixed = (cents / 100).toFixed(2);
    var parts = fixed.split('.');
    var thousands = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var values = {
      amount: thousands(parts[0], ',') + '.' + parts[1],
      amount_no_decimals: thousands(String(Math.round(cents / 100)), ','),
      amount_with_comma_separator: thousands(parts[0], '.') + ',' + parts[1],
      amount_no_decimals_with_comma_separator: thousands(String(Math.round(cents / 100)), '.'),
      amount_with_apostrophe_separator: thousands(parts[0], "'") + '.' + parts[1]
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) { return values[key] != null ? values[key] : m; });
  }

  /* ---------- price of the selected variant ---------- */
  function paintPrice(card) {
    var v = selectedVariant(card);
    if (!v) return;
    var pctLeft = parseFloat(card.dataset.tgmPctLeft || '1');
    var fixed = parseFloat(card.dataset.tgmFixed || '0');
    if (!isFinite(pctLeft)) pctLeft = 1;
    if (!isFinite(fixed)) fixed = 0;
    var price = Math.round(v.price * pctLeft - fixed);
    var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
    var hasSaving = compare > price;
    card.querySelectorAll('.upsell__price').forEach(function (box) {
      var now = box.querySelector('.regular-price');
      var was = box.querySelector('.compare-price');
      var save = box.querySelector('.tgm-upsell-save');
      if (now) now.textContent = money(price, card);
      if (was) { was.textContent = money(compare, card); was.classList.toggle('hidden', !hasSaving); }
      var label = card.dataset.tgmSaveLabel || '';
      if (hasSaving && label) {
        if (!save) {
          save = document.createElement('span');
          save.className = 'tgm-upsell-save';
          box.appendChild(save);
        }
        save.textContent = label.replace('[pct]', Math.round(((compare - price) * 100) / compare));
        save.hidden = false;
      } else if (save) {
        save.hidden = true;
      }
    });
  }

  /* ---------- cart state ---------- */
  function linesFor(card, cart) {
    var handle = card.dataset.handle;
    return (cart.items || []).filter(function (item) {
      return item.handle === handle && !(item.properties && item.properties._tgm_gift);
    });
  }
  function ownLine(card, cart) {
    var lines = linesFor(card, cart);
    return lines.filter(function (l) { return l.properties && l.properties[PROP]; })[0] || lines[0] || null;
  }
  function paintCard(card, cart) {
    var line = cart ? ownLine(card, cart) : null;
    card.dataset.tgmAdded = line ? 'true' : 'false';
    card.dataset.selected = 'false';
    var btn = card.querySelector('.upsell-toggle-btn');
    if (btn) {
      btn.setAttribute('aria-pressed', line ? 'true' : 'false');
      var name = (card.querySelector('.upsell__title h3') || {}).textContent || '';
      btn.setAttribute('aria-label', (line ? 'Remove ' : 'Add ') + name.trim());
    }
    if (line && line.variant_id !== Number(card.dataset.id)) {
      // Show the variant that is really in the cart.
      var v = variants(card).filter(function (x) { return Number(x.id) === Number(line.variant_id); })[0];
      if (v) {
        card.dataset.id = String(v.id);
        card.querySelectorAll('.upsell__variant-picker select').forEach(function (sel, i) {
          var val = v.options && v.options[i];
          if (val != null && sel.value !== val) sel.value = val;
        });
        paintPrice(card);
      }
    }
  }
  function paintAll(cart) {
    lastCart = cart;
    cards().forEach(function (card) { paintCard(card, cart); });
  }
  function readCart() {
    return request('/cart.js').then(function (cart) { paintAll(cart); return cart; });
  }
  function afterWrite() {
    // Refresh the drawer, the cart page and the count bubble the same way the cart rewards do.
    var done = window.TGMRewards && window.TGMRewards.refresh ? window.TGMRewards.refresh('upsell') : Promise.resolve();
    try { document.dispatchEvent(new CustomEvent('tgm:upsell-changed')); } catch (e) { /* old browsers */ }
    return Promise.resolve(done).then(readCart);
  }

  /* ---------- add / remove ---------- */
  function setBusy(card, busy) {
    card.dataset.tgmBusy = busy ? 'true' : 'false';
  }
  function add(card) {
    var id = Number(card.dataset.id);
    if (!id) return Promise.resolve();
    var props = {}; props[PROP] = '1';
    return requestRetry('/cart/add.js', { items: [{ id: id, quantity: 1, properties: props }] });
  }
  function remove(card, cart) {
    var line = ownLine(card, cart);
    if (!line) return Promise.resolve();
    return requestRetry('/cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity - 1) });
  }
  function toggle(card) {
    if (card.dataset.tgmBusy === 'true') return;
    setBusy(card, true);
    var wasAdded = card.dataset.tgmAdded === 'true';
    // Optimistic paint: the button answers at once.
    card.dataset.tgmAdded = wasAdded ? 'false' : 'true';
    request('/cart.js')
      .then(function (cart) {
        var inCart = !!ownLine(card, cart);
        if (wasAdded && inCart) return remove(card, cart);
        if (!wasAdded && !inCart) return add(card);
        return null;
      })
      .then(afterWrite)
      .catch(function () { return readCart(); })
      .then(function () { setBusy(card, false); }, function () { setBusy(card, false); });
  }
  // A new colour or buckle on a card that is already in the cart swaps the line.
  function variantChanged(card) {
    paintPrice(card);
    if (card.dataset.tgmAdded !== 'true') return;
    setBusy(card, true);
    request('/cart.js')
      .then(function (cart) {
        var line = ownLine(card, cart);
        if (!line || line.variant_id === Number(card.dataset.id)) return null;
        return requestRetry('/cart/change.js', { id: line.key, quantity: 0 }).then(function () { return add(card); });
      })
      .then(afterWrite)
      .catch(function () { return readCart(); })
      .then(function () { setBusy(card, false); }, function () { setBusy(card, false); });
  }

  /* ---------- wiring ---------- */
  function wire() {
    // Capture phase: runs before the theme's own toggle, which would only mark the card.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-tgm-instant="true"] .upsell-toggle-btn');
      if (!btn) return;
      var card = btn.closest('[data-tgm-instant="true"]');
      if (!card) return;
      // Clicks on the selects inside a container-style toggle are not toggles.
      if (e.target.closest('select, option, a')) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggle(card);
    }, true);
    cards().forEach(function (card) {
      var picker = card.querySelector('.upsell__variant-picker');
      // The theme updates data-id on change; read it right after.
      if (picker) picker.addEventListener('change', function () { setTimeout(function () { variantChanged(card); }, 0); });
      paintPrice(card);
    });
    // Keep the cards in step with the cart after any change made elsewhere.
    ['cart:updated', 'cart:refresh', 'cart:update', 'cartQuantityUpdated'].forEach(function (name) {
      document.addEventListener(name, function (e) {
        var cart = e && e.detail && e.detail.cart;
        if (cart && cart.items) paintAll(cart);
        else readCart().catch(function () { /* ignore */ });
      });
    });
    // The watch's own Add to cart: make sure no card is marked for the theme at submit time.
    document.addEventListener('submit', function () {
      cards().forEach(function (card) { card.dataset.selected = 'false'; });
    }, true);
  }
  function init() {
    if (!cards().length) return;
    wire();
    readCart().catch(function () { /* the cards stay on Add */ });
  }
  window.TGMUpsells = { refresh: readCart };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
